module.exports = __webpack_public_path__ + "static/sizzle_mobile-d4175f90964dbf9d9e00b218a4390375.mp4";